<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7.38976 1.25277C7.72678 0.915743 8.27321 0.915743 8.61024 1.25277L11.6787 4.32126C12.0158 4.65829 12.0158 5.20472 11.6787 5.54175C11.3417 5.87878 10.7953 5.87878 10.4583 5.54175L8.86301 3.94651V11.0685C8.86301 11.5451 8.47663 11.9315 8 11.9315C7.52337 11.9315 7.13699 11.5451 7.13699 11.0685V3.94651L5.54175 5.54175C5.20472 5.87878 4.65829 5.87878 4.32126 5.54175C3.98424 5.20472 3.98424 4.65829 4.32126 4.32126L7.38976 1.25277ZM1.86301 10.9726C2.33964 10.9726 2.72603 11.359 2.72603 11.8356C2.72603 12.2171 2.87757 12.5829 3.14731 12.8527C3.41706 13.1224 3.78291 13.274 4.16438 13.274H11.8356C12.2171 13.274 12.5829 13.1224 12.8527 12.8527C13.1224 12.5829 13.274 12.2171 13.274 11.8356C13.274 11.359 13.6604 10.9726 14.137 10.9726C14.6136 10.9726 15 11.359 15 11.8356C15 12.6749 14.6666 13.4797 14.0732 14.0732C13.4797 14.6666 12.6749 15 11.8356 15H4.16438C3.32514 15 2.52026 14.6666 1.92683 14.0732C1.33339 13.4797 1 12.6749 1 11.8356C1 11.359 1.38638 10.9726 1.86301 10.9726Z"
            :fill="fill" />
    </svg>
</template>
<script>
export default {
    props: {
        fill: {
            type: String,
            default: '#1A73E8',
        }
    }
}
</script>